import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoLibriSocialiStep2Component } from './conservazione-carica-documento-libri-sociali-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-libri-sociali-step2', {
            url: '/conservazione-carica-libri-sociali',
            ncyBreadcrumb: {
                label: 'Carica Libri Sociali',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-libri-sociali-step2 flex="100"></conservazione-carica-documento-libri-sociali-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoLibriSocialiStep2Module: string = ng
    .module('conservazione-carica-documento-libri-sociali-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoLibriSocialiStep2', ConservazioneCaricaDocumentoLibriSocialiStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-libri-sociali-step2/conservazione-carica-documento-libri-sociali-step2.module.ts